module.exports = __webpack_public_path__ + "static/media/platinum-member-desktop.fef79245.svg";